import {
  NeedName,
  ProductName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";
import {
  AKA_GROUP_LIFE_COVERAGES,
  AkaCriticalIllness,
  CriticalIllnessCoverage,
  DeathCoverage,
  DisabilityCoverage,
} from "Store/interfaces/products/coverage";

import { AdviceCoverageName } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export const mapToAdviceCoverageName = (
  needName: NeedName,
): AdviceCoverageName[] => {
  switch (needName) {
    case NeedName.LIFE:
      return [...AKA_GROUP_LIFE_COVERAGES, DeathCoverage.DEATH_NOT_SMOKER];
    case NeedName.DISABILITY:
      return [...AKA_GROUP_LIFE_COVERAGES, DisabilityCoverage.DISABILITY_FLEX];
    case NeedName.CRITICAL_ILLNESS:
      return [
        AkaCriticalIllness.AKA_CRITICAL_ILLNESS,
        AkaCriticalIllness.AKA_CRITICAL_ILLNESS_CO_INSURED,
        AkaCriticalIllness.AKA_CRITICAL_ILLNESS_MEMBER_AND_CO_INSURED,
        CriticalIllnessCoverage.CRITICAL_ILLNESS_NOT_SMOKER,
      ];
    default:
      throw Error("Unable to map need name to advice coverage");
  }
};

export const mapInsuranceNameToAdviceCoverageName = (
  insuranceName: ProductName,
): AdviceCoverageName[] => {
  switch (insuranceName) {
    case INSURANCE_NAME_VALUE.AKA_GROUP_LIFE:
      return AKA_GROUP_LIFE_COVERAGES;
    case INSURANCE_NAME_VALUE.DISABILITY_FLEX:
      return [DisabilityCoverage.DISABILITY_FLEX];
    case INSURANCE_NAME_VALUE.DEATH:
      return [DeathCoverage.DEATH_NOT_SMOKER];
    case INSURANCE_NAME_VALUE.AKA_CRITICAL_ILLNESS:
      return [
        AkaCriticalIllness.AKA_CRITICAL_ILLNESS,
        AkaCriticalIllness.AKA_CRITICAL_ILLNESS_CO_INSURED,
        AkaCriticalIllness.AKA_CRITICAL_ILLNESS_MEMBER_AND_CO_INSURED,
      ];
    case INSURANCE_NAME_VALUE.CRITICAL_ILLNESS:
      return [CriticalIllnessCoverage.CRITICAL_ILLNESS_NOT_SMOKER];
    default:
      throw Error("Unable to map insurance name to advice coverage");
  }
};
